// extracted by mini-css-extract-plugin
module.exports = {"ido":"index_ido__313Io","idotext":"index_idotext__DupBi"};